module.exports = __webpack_public_path__ + "static/media/folder-plus.339ab51b.svg";